/**
 * Arrow is rendered automatically by {@link TooltipContent}.
 * Kept for API compatibility; extra instances are ignored.
 */
function TooltipArrow() {
  return null
}

export default TooltipArrow
